import httpService from '@Utils/httpService';

const baseUrl = 'api/chats';

export default {
  generate(payload) {
    return httpService.post({
      url: `${baseUrl}/generate`,
      data:payload
    });
  },
  generateList(messages) {
    return httpService.post({
      url: `${baseUrl}/generate/list`,
      data:messages
    });
  },
   getThreadId() {
    return httpService.get({
      url: `${baseUrl}/thread`
    });
  },
}